/* eslint-disable @typescript-eslint/default-param-last */
import {
  TInterviewerType,
  IQuestionScoreSuccessAction,
  TReducerAction,
} from "@/types/interviewer.types";
import {
  UPDATE_INTERVIEWER_DETAILS,
  CREATE_INTERVIEW_RATING,
  UPDATE_INTERVIEW_RATING,
  GET_SCORECARD,
  SUBMIT_QUESTION_SCORE,
  UPDATE_QUESTION_SCORE,
} from "@/constants/ActionTypes";
import initialState from "@/store/initialState";

const interviewerRatingsReducer = (
  state = initialState.interviewerRatings,
  action: TReducerAction,
) => {
  switch (action.type) {
    case `${CREATE_INTERVIEW_RATING}_SUCCESS`: {
      const { rating } = action as TInterviewerType;
      return {
        ...state,
        evaluation_ratings: { ...rating.evaluation_ratings },
        feedbackSlug: rating.slug,
        status: rating.status,
      };
    }
    case `${UPDATE_INTERVIEW_RATING}_SUCCESS`:
    case `${UPDATE_INTERVIEWER_DETAILS}_SUCCESS`: {
      const { rating } = action as TInterviewerType;
      return {
        ...state,
        evaluation_ratings: {
          ...state.evaluation_ratings,
          ...rating.evaluation_ratings,
        },
        status: rating.status,
      };
    }
    case `${GET_SCORECARD}_SUCCESS`: {
      const { rating } = action as TInterviewerType;
      return {
        ...state,
        feedbackSlug: rating.slug,
        evaluation_ratings: rating.evaluation_ratings,
        status: rating.status,
        question_ratings: {
          ...state.question_ratings,
          ...rating.question_ratings,
        },
      };
    }
    case `${SUBMIT_QUESTION_SCORE}_SUCCESS`:
    case `${UPDATE_QUESTION_SCORE}_SUCCESS`: {
      const { questionSlug, ratingData } =
        action as IQuestionScoreSuccessAction;
      return {
        ...state,
        question_ratings: {
          ...state.question_ratings,
          [questionSlug]: ratingData,
        },
      };
    }
    default:
      return state;
  }
};

export default interviewerRatingsReducer;
